import React from "react";
import { Check } from "lucide-react";
import { Badge } from "./Primitives";
import { cn } from "../lib/utils";

const SEV_BADGE = {
  critical: "critical",
  warning: "warning",
  info: "info",
  high: "critical",
  medium: "warning",
  low: "info",
};

export default function RecommendedActionCard({ action, index, resolved, onApprove, onDefer }) {
  const sev = SEV_BADGE[action.severity] || "info";
  return (
    <div
      data-testid={`action-card-${index}`}
      className={cn("border rounded-sm p-3",
        resolved === "approved" && "border-success/40 bg-success/5",
        resolved === "deferred" && "border-border/60 bg-surface-2/40 opacity-70",
        !resolved && (
          sev === "critical" ? "border-critical/30" :
          sev === "warning" ? "border-warning/30" : "border-border"
        ))}>
      <div className="flex items-start gap-3">
        <div className={cn("w-7 h-7 rounded-sm flex items-center justify-center font-mono-tabular text-[11px] font-semibold shrink-0",
          sev === "critical" && "bg-critical/15 text-critical",
          sev === "warning" && "bg-warning/15 text-warning",
          sev === "info" && "bg-info/15 text-info")}>
          A{index + 1}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display font-semibold text-[13px] leading-snug">{action.title}</div>
          <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-[10px]">
            <Tag label="Owner" value={action.owner} />
            <Tag label="ETA" value={action.eta} />
            <Badge status={sev}>{action.severity}</Badge>
          </div>
          <p className="text-[11.5px] text-fg/85 leading-relaxed mt-2">
            <span className="text-success font-semibold">Impact:</span> {action.expected_impact}
          </p>
          {action.trade_off && (
            <p className="text-[11.5px] text-muted leading-relaxed mt-1">
              <span className="text-warning font-semibold">Trade-off:</span> {action.trade_off}
            </p>
          )}
        </div>
      </div>
      {!resolved && (
        <div className="mt-2.5 flex items-center gap-2 pl-10">
          <button
            data-testid={`approve-action-${index}`}
            onClick={onApprove}
            className="text-[11px] px-2.5 py-1 bg-primary text-primary-fg rounded-sm hover:opacity-90 inline-flex items-center gap-1">
            <Check size={11} /> Approve
          </button>
          <button
            data-testid={`defer-action-${index}`}
            onClick={onDefer}
            className="text-[11px] px-2.5 py-1 border border-border text-muted hover:text-fg rounded-sm">
            Defer
          </button>
        </div>
      )}
      {resolved && (
        <div className="mt-2 pl-10 text-[11px] font-mono-tabular uppercase tracking-wider"
             style={{ color: resolved === "approved" ? "rgb(var(--success))" : "rgb(var(--muted))" }}>
          {resolved === "approved" ? "✓ Approved · routed to action queue" : "deferred for 24h"}
        </div>
      )}
    </div>
  );
}

function Tag({ label, value }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="uppercase tracking-widest text-subtle">{label}</span>
      <span className="text-fg/90 font-medium">{value}</span>
    </span>
  );
}
